import { Parser } from 'html-to-react';

const htmlParser = new Parser();

export const transformHtmlInJSX = html => htmlParser.parse(html);

export const transformNewlinesInBrTags = str => str.replace(/\n/g, '<br>');
